import httpRequest from "../../service/httpRequest";

// Centro de notificaciones para los BroadcastMessage del negocio.
// El historial (items) viene del backend (/dashboard/broadcast/list); el estado de LEÍDO es por
// usuario y se guarda en localStorage (el `seen` del backend es global por negocio y se deja solo
// para el popup). Ver deuda técnica: modelo BroadcastRead por-usuario para sincronizar entre dispositivos.

const READ_KEY = (userId) => `contablus.notifRead.${userId || "anon"}`;

function loadReadIds(userId) {
    try {
        const raw = localStorage.getItem(READ_KEY(userId));
        const ids = raw ? JSON.parse(raw) : [];
        return Array.isArray(ids) ? ids : [];
    } catch (e) { return []; }
}

function saveReadIds(userId, ids) {
    try { localStorage.setItem(READ_KEY(userId), JSON.stringify(ids)); } catch (e) { /* noop */ }
}

const state = {
    items: [],
    readIds: [],
    userId: null,
};

const getters = {
    notifications: (state) => state.items,
    unreadNotifications: (state) => state.items.filter((m) => !state.readIds.includes(m.id)),
    unreadCount: (state) => state.items.filter((m) => !state.readIds.includes(m.id)).length,
};

const actions = {
    // Arranque: fija el usuario, carga su estado de leídos (localStorage) y trae el historial.
    async initNotifications({ commit, dispatch }, userId) {
        commit("setNotifUserId", userId || null);
        commit("setNotifReadIds", loadReadIds(userId));
        await dispatch("fetchNotifications");
    },
    async fetchNotifications({ commit }) {
        const res = await httpRequest.getBroadcastMessages();
        if (res && res.status === 200 && Array.isArray(res.data)) {
            commit("setNotifItems", res.data);
        }
    },
    // Llega un broadcast en vivo por WebSocket: lo sumamos al centro (sin duplicar).
    addLiveNotification({ commit }, message) {
        if (message && message.id) commit("prependNotifItem", message);
    },
    markNotificationRead({ commit, state }, id) {
        commit("addNotifReadId", id);
        saveReadIds(state.userId, state.readIds);
    },
    markAllNotificationsRead({ commit, state }) {
        commit("setAllNotifRead");
        saveReadIds(state.userId, state.readIds);
    },
};

const mutations = {
    setNotifUserId(state, id) { state.userId = id; },
    setNotifReadIds(state, ids) { state.readIds = Array.isArray(ids) ? ids : []; },
    setNotifItems(state, items) { state.items = items || []; },
    prependNotifItem(state, message) {
        if (state.items.some((m) => m.id === message.id)) return;
        state.items = [message, ...state.items];
    },
    addNotifReadId(state, id) {
        if (!state.readIds.includes(id)) state.readIds = [...state.readIds, id];
    },
    setAllNotifRead(state) {
        state.readIds = Array.from(new Set([...state.readIds, ...state.items.map((m) => m.id)]));
    },
};

export default { state, getters, actions, mutations };
